module.exports = __webpack_public_path__ + "img/sankaku_21_red.c61d55d9.png";